import { render } from "./wButtonEdit.vue?vue&type=template&id=2c1a957a&ts=true"
import script from "./wButtonEdit.vue?vue&type=script&lang=ts"
export * from "./wButtonEdit.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__